import DateCellProps from './type';
import { dateToLocalIsoString, formatTimestamp, getTimeDifference } from '../../../utils';
import { DateCellStyled } from './styled';

const DateCell = ({ ...props }: DateCellProps) => {
  const {
    date: rawDate = '',
    showTimeDifference = false,
    onlyDate = true,
    expectValidDate = true,
    style,
    ...rest
  } = props;
  if (!rawDate)
    return (
      <DateCellStyled {...rest} style={style}>
        -
      </DateCellStyled>
    );
  const date = rawDate instanceof Date ? dateToLocalIsoString(rawDate) : rawDate;
  const isInvalidDateString = Number.isNaN(Date.parse(date));

  if (showTimeDifference) {
    if (typeof rawDate === 'string')
      return (
        <DateCellStyled {...rest} style={style}>
          {rawDate}
        </DateCellStyled>
      );
    const timeDifference = getTimeDifference(rawDate);
    return (
      <DateCellStyled {...rest} style={style}>
        {`${timeDifference.days} días, ${timeDifference.hours} hrs, ${timeDifference.minutes} minutos`}
      </DateCellStyled>
    );
  }
  return (
    <DateCellStyled
      {...rest}
      style={{ ...style, ...(expectValidDate && isInvalidDateString ? { color: 'red' } : {}) }}
    >
      {isInvalidDateString ? date : formatTimestamp(date, { onlyDate })}
    </DateCellStyled>
  );
};

export default DateCell;
